import { useState } from 'react'
import { formatQty, parseQtyTenths, type CriticalPartDTO } from '@wf/shared'
import { useCreateRestock } from './useInventory'

/** Eine Karte in „Bestand kritisch": Teil unter Sicherheitsbestand + „Zu bestellen" (Menge vorausgefüllt). */
function CriticalCard({ part }: { part: CriticalPartDTO }) {
  const restock = useCreateRestock()
  const [open, setOpen] = useState(false)
  const suggestion = Math.max(part.safetyStockTenths - part.stockTenths, 1)
  const [qty, setQty] = useState(() => formatQty(suggestion))

  return (
    <div className="wf-card wf-card--wartet wf-card--static">
      <div>
        <div className="wf-card__title">{part.name}</div>
        <div className="wf-card__meta wf-tnum">{part.partNumber}</div>
      </div>
      <div className="wf-card__meta">
        Bestand {formatQty(part.stockTenths)} {part.unit} · Sicherheit {formatQty(part.safetyStockTenths)} {part.unit}
      </div>
      {part.openRestock ? (
        <span className="wf-pill">in Bestellung</span>
      ) : open ? (
        <div className="wf-line-add">
          <input
            className="wf-input wf-tnum"
            inputMode="decimal"
            aria-label="Bestellmenge"
            value={qty}
            onChange={(e) => setQty(e.target.value)}
          />
          <button
            type="button"
            className="wf-btn"
            disabled={restock.isPending}
            onClick={() => restock.mutate({ partId: part.id, quantityTenths: parseQtyTenths(qty) }, { onSuccess: () => setOpen(false) })}
          >
            Auf Bestell-Liste
          </button>
          <button type="button" className="wf-btn wf-btn--ghost" onClick={() => setOpen(false)}>
            Abbrechen
          </button>
        </div>
      ) : (
        <button type="button" className="wf-btn wf-btn--ghost wf-btn--sm" onClick={() => setOpen(true)}>
          Zu bestellen
        </button>
      )}
    </div>
  )
}

export function CriticalSection({ parts }: { parts: CriticalPartDTO[] }) {
  if (parts.length === 0) return null
  return (
    <div>
      <h3 className="wf-sectionhead">Bestand kritisch ({parts.length})</h3>
      <div className="wf-linelist">
        {parts.map((part) => (
          <CriticalCard key={part.id} part={part} />
        ))}
      </div>
    </div>
  )
}
